import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import {Container,Card,Form,Button} from "react-bootstrap";
import axios from 'axios';
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { toast } from "react-hot-toast";
import ModulesList from '../../../Components/ModulesList/ModulesList';
import { slugify } from '../../../utils/slugify';


export default function EditService() {
  const navigate = useNavigate();

  const [screenloader,setScreenloader] = useState(true);
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [active, setActive] = useState(1);
  const [modules, setModules] = useState([]);

  const Param1 = useParams();
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const loc = location.pathname === `/ShowService/${Param1}` ? true : false;
  const id = Param1.id;
  
  const [content, setContent] = useState("");
  
  useEffect(()=>{
    getServiceDetail();
  },[]);

  
  const Actions=()=>{
    return(
          <>
            <div className='mb-3 text-left'>
              <Button onClick={UpdateData} variant="success">Save Changes</Button>
            </div>
            {/* <div className='mb-3 text-left'>
              <Button onClick={()=>{navigate(-1)}} variant="danger">Back</Button>
            </div> */}
          </>
      )
  }

  const getServiceDetail = async () => {
    setScreenloader(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/admin/services/${id}`, {
        headers: {
          'access-token': localStorage.getItem('accessToken'),
        },
      });
  
      setScreenloader(false);
      if (res.data.status) {
        if (res.data.service) {
          setName(res.data.service.name);
          setSlug(res.data.service.slug);
          setActive(res.data.service.active);
          setModules(res.data.service.modules || []);
        } else {
          toast.success('Service not found!');
        }
      } else {
        toast.error('Something Went Wrong!');
        console.log(res.data);
      }
    } catch (er) {
      setScreenloader(false);
      if (er.response?.data?.message) {
        toast.error(er.response.data.message);
      } else {
        console.log(er);
        toast.error("Something Went Wrong");
      }
    }
  };

  const UpdateData = async () => {
    if (!name || !slug) {
      toast.error('Name and slug cannot be empty');
      return;
    }
    setScreenloader(true);
    await axios.put(`${process.env.REACT_APP_API_URL}/admin/services/${id}`, {
      name,
      slug,
      active,
      modules,
    }, {
      headers: {
        'access-token': localStorage.getItem('accessToken'),
      }
    })
    .then(res => {
      setScreenloader(false);
      if (res.data.status) {
        toast.success('Service Updated Successfully');
        setName(res.data.service.name);
        setSlug(res.data.service.slug);
        setActive(res.data.service.active);
        setModules(res.data.service.modules || []);
      } else {
        toast.error('Something Went Wrong');
        console.log(res.data);
      }
    })
    .catch(er => {
      setScreenloader(false);
      if (er.response?.data?.message) {
        toast.error(er.response.data.message);
      } else {
        console.log(er);
        toast.error("Something Went Wrong");
      }
    });
  };

  const handleNameChange = (e) => {
    const newName = e.target.value;
    setName(newName);
    // Only update slug if it hasn't been manually edited
    if (slug === slugify(name)) {
      setSlug(slugify(newName));
    }
  };

  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>
            <h1></h1>
            <Container fluid className='behind'>
              <Card className='mt-4'>
                <Card.Header>
                  <div className='d-flex justify-content-between'>
                    <Card.Title as="h3" className='text-muted'>Edit Service # {id}</Card.Title>
                    {/* <Button className="btn admin-btn"onClick={UpdateData} variant="success">Save Changes</Button> */}
                  </div>
                </Card.Header>
                <Card.Body>                  
                  <div className='row mb-4'>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Name
                      </Card.Subtitle>
                      <Form.Control
                        className="fontBold"
                        required
                        placeholder="Enter Service Name"
                        title="Name"
                        type="text"
                        name="name"
                        value={name}
                        onChange={handleNameChange}
                      />
                    </div>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Slug
                      </Card.Subtitle>
                      <Form.Control
                        className="fontBold"
                        required
                        placeholder="Enter Slug"
                        title="Slug"
                        type="text"
                        name="slug"
                        value={slug}
                        onChange={(e) => setSlug(e.target.value)}
                      />
                    </div>
                    <div className='col-lg-4 col-md-4 col-6'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Active
                      </Card.Subtitle>
                      <Form.Control
                        as="select"
                        className="fontBold"
                        required
                        title="Active"
                        name="active"
                        value={active}
                        onChange={(e) => setActive(parseInt(e.target.value))}
                      >
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </Form.Control>
                    </div>
                  </div>
                  {/* <div className='row my-4'>
                    
                  </div>
                  <div className='row my-4'>
                    
                  </div> */}

                  
                  <div className='row'>
                      <div className='d-flex justify-content-between align-items-center mb-3'>
                        <Card.Subtitle className='text-muted mb-0'>
                          Modules
                        </Card.Subtitle>
                        <Button className="btn admin-btn" onClick={UpdateData} variant="success">Save Changes</Button>
                      </div>
                      <ModulesList
                        modules={modules}
                        setModules={setModules}
                      />
                  </div>         
                  {/* {Actions()} */}
                </Card.Body>
                <Card.Footer>
                  <div className='d-flex flex-column flex-sm-row gap-2 mb-3'>
                    <Button className="btn admin-btn" onClick={UpdateData} variant="success">Save Changes</Button>
                    <Button style={{ backgroundColor: '#5f75a5ff', color: '#d8d6d6ff', border: 'none'}} onClick={()=>{navigate(-1)}} variant="danger">Back</Button>
                  </div>
                </Card.Footer>
              </Card>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
}
